<template>
  <v-snackbar
    :timeout="5000"
    auto-heigth
    multi-line
    v-model="successFull"
    color="info"
    absolute
    centered
    class="mt-15"
  >
    <v-layout align-center pr-4>
      <v-icon class="pr-3" dark large>mdi-printer</v-icon>
      <v-layout column>
        <div>
          <strong>SUCCES</strong>
        </div>
        <div>
          Your report is on its way<br />Please note that this email may end up
          in your spam email box.
        </div>
      </v-layout>
    </v-layout>
  </v-snackbar>
</template>

<script>
export default {
  name: "report",
  methods: {},

  data() {
    return {
      successFull: false,
    };
  },
  created() {
    // eslint-disable-next-line no-undef
    EventBus.$on("report", (data) => {
      this.successFull = data;
    });
  },
};
</script>

<style scoped></style>
